import { createPromiseAction } from "@adobe/redux-saga-promise";

export const CANVA_DESIGNS_CALL = "CANVA_DESIGNS_CALL";
export const CANVA_DESIGNS_ADD_CALL_PROMISE = "CANVA_DESIGNS_ADD_CALL_PROMISE";
export const CANVA_DESIGNS_BY_ID_CALL_PROMISE = "CANVA_DESIGNS_BY_ID_CALL_PROMISE";

export const callCanvaDesignAddPromise = createPromiseAction(CANVA_DESIGNS_ADD_CALL_PROMISE);
export const callCanvaDesignsByIdPromise = createPromiseAction(CANVA_DESIGNS_BY_ID_CALL_PROMISE);


export function callCanvaDesigns(page, withoutLoading) {
  return { type: CANVA_DESIGNS_CALL, payload: { page, withoutLoading } };
}
